import styled from '@emotion/styled/macro';

export const Title = styled.h1`
    color: ${props => props.theme.colours.textGreen};
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-weight: 700;
    font-size: ${props => props.theme.fontSize.xlarge};
    line-height: 28px;
    margin-bottom: ${props => props.theme.spacing.xlarge};
    text-align: center;
    text-transform: uppercase;
`;

export const Commiseration = styled.p`
    font-weight: 400;
    line-height: 22px;
    font-size: ${props => props.theme.fontSize.medium};
    margin-bottom: 20px;
    text-align: center;
`;

export const SubHeading = styled.h2`
    font-weight: 500;
    font-size: ${props => props.theme.fontSize.large};
    margin-bottom: 12px;
    color: ${props => props.theme.colours.textDark};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    text-align: center;
`;

export const WinnerCards = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;

    & > div {
        margin: 8px auto;
    }

    & > div:first-of-type {
        margin: 0;
    }

    & > div:nth-of-type(2) {
        margin: 16px auto 6px auto;
    }

    & > div:last-child {
        margin: 8px 0 0 0;
    }
`;

export const PlayItvWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
`;

export const ButtonWrapper = styled.div`
    margin-bottom: ${props => props.theme.spacing.large};
    width: 100%;
`;
